import React from "react";
import { getIcon } from "../../../assets/icons/iconRegistry";
import { IconNames } from "@shared/enums/icons.enums";
import { cn } from "@shared/helpers/classNames.helper";

interface IProps {
    iconName: string | IconNames;
    wrapperStyle?: string;
    svgProp?: React.SVGProps<SVGSVGElement>;
    className?: string | undefined;
}

export const SvgIcon = (props: IProps) => {
    const { iconName, wrapperStyle, svgProp, className } = props;
    const Icon = getIcon(iconName as string);
    return (
        <>
            {Icon && <Icon className={cn(wrapperStyle, className)} {...svgProp} />}
        </>
    );
};
